import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@cmps/ng-bootstrap';
import {
    CmpsCommitmentFocusStatusModule,
    CmpsCommitmentSummaryModule,
} from '@cmps/ng-kit';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsAccordionModule,
    CmpsButtonGroupModule,
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsRadioModule,
    CmpsSnackBarModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { NextCoachingService } from '../coaching-base/coaching.service';
import { DraftCommitmentService } from '../coaching-base/draft-commitment.service';
import { CmpsNoteModule } from '../coaching-note/notes.module';
import { CmpsObservationModule } from '../coaching-observation/coaching-observation.module';
import { ExperimentalNgGridModule } from '../coaching-observation/experimental.grid';
import { CmpsCoachingTagsModule } from '../coaching-tags/coaching-tags.module';
import { CmpCoachingBlButtonModule } from '../coaching/behaviour-library';
import { CmpsCaMeetModule } from '../coaching/coach-assist';
import { CmpsCommitmentNarrativeModule } from '../coaching/detail/commitment/commitment-narrative';
import { CmpsCoachingFocusSelectorModule } from '../coaching/focus-selector/focus-selector.module';
import { FocusSelectorService } from '../coaching/services/focus-selector.service';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';

import { CmpsAlertModule } from './alert/alert.module';
import { CmpsChartModule } from './chart.module';
import { TranslationIdMap } from './coaching-commitment.i18n';
import { CloseGoalModalCommitmentComponent } from './commitment-close-goal/close-goal-modal.commitment.component';
import { CloseCommitmentComponent } from './commitment-close/close.commitment.component';
import { DisputeCommitmentComponent } from './commitment-dispute/dispute.commitment.component';
import { GoalChartCommitmentComponent } from './commitment-goal-chart/goal-chart.commitment.component';
import { GoalDetailCommitmentComponent } from './commitment-goal-detail/detail.goal.commitment.component';
import { GoalGridCommitmentComponent } from './commitment-goal-grid/goal-grid.commitment.component';
import { GoalHistoryCommitmentComponent } from './commitment-goal-history/history.goal.commitment.component';
import { GoalsCommitmentComponent } from './commitment-goals/goals.commitment.component';
import { ObservationsCommitmentComponent } from './commitment-observations/observations.commitment.component';
import { DisputedGoalDialogComponent } from './commitment-recent-goals/disputed-goal-dialog.component';
import { RecentGoalsCommitmentComponent } from './commitment-recent-goals/recent.goal.commitment.component';
import { SharedGoalsCommitmentComponent } from './commitment-shared-goals/shared.goals.commitment.component';
import { CommitmentSummaryDialog } from './commitment-summary/commitment-summary-dialog.component';
import { DiffItemFilter } from './commitment-summary/commitment-summaryItems-filter.pipe';
import { CmpsDiffItemActionLabelPipe } from './commitment-summary/diff-item-action-label.pipe';
import { CmpsDiffItemActionValuePipe } from './commitment-summary/diff-item-action-value.pipe';
import { CmpsDiffItemElementLabelPipe } from './commitment-summary/diff-item-element-label.pipe';
import { CmpsEditableTimerComponent } from './commitment-timer/timer.commitment.component';
import { CommitmentComponent } from './commitment/commitment.component';
import { CmpsEventBoxModule } from './event-box';
import { CmpsGoalBoxModule } from './goal-box';
import { GoalService } from './goal/goal.service';
import { CommitmentService } from './services/commitment.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        SelectModule,
        CmpsCommonModule,
        CmpsNoteModule,
        CmpsObservationModule,
        CmpsCoachingTagsModule,
        CmpsChartModule,
        CmpsCheckboxModule,
        CmpsLazyI18nModule,
        ExperimentalNgGridModule,
        CmpsEventBoxModule,
        CmpsButtonModule,
        CmpsIconModule,
        CmpsAlertModule,
        CmpsGoalBoxModule,
        CmpsCommitmentSummaryModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsDialogModule,
        CmpsAccordionModule,
        CmpsRadioModule,
        CmpsSnackBarModule,
        CmpsCommitmentFocusStatusModule,
        NgxSliderModule,
        CmpsTooltipModule,
        CmpsCoachingFocusSelectorModule,
        CmpsCommitmentNarrativeModule,
        CmpsCommitmentSummaryModule,
        CmpCoachingBlButtonModule,
        CmpsButtonGroupModule,
        CmpsCaMeetModule,
    ],
    declarations: [
        ObservationsCommitmentComponent,
        GoalsCommitmentComponent,
        CloseGoalModalCommitmentComponent,
        DisputeCommitmentComponent,
        CloseCommitmentComponent,
        CommitmentComponent,
        CmpsEditableTimerComponent,
        RecentGoalsCommitmentComponent,
        GoalDetailCommitmentComponent,
        GoalHistoryCommitmentComponent,
        SharedGoalsCommitmentComponent,
        GoalChartCommitmentComponent,
        GoalGridCommitmentComponent,
        CommitmentSummaryDialog,
        DiffItemFilter,
        CmpsDiffItemElementLabelPipe,
        CmpsDiffItemActionLabelPipe,
        CmpsDiffItemActionValuePipe,
        DisputedGoalDialogComponent,
    ],
    exports: [RecentGoalsCommitmentComponent, GoalChartCommitmentComponent],
})
export class CmpsCommitmentModule {
    static forRoot(): ModuleWithProviders<CmpsCommitmentModule> {
        return {
            ngModule: CmpsCommitmentModule,
            providers: [
                NextCoachingService,
                DraftCommitmentService,
                CommitmentService,
                FocusSelectorService,
                GoalService,
            ],
        };
    }
}
